import { render, staticRenderFns } from "./goods-info.vue?vue&type=template&id=bebc30fe&scoped=true"
import script from "./goods-info.vue?vue&type=script&lang=js"
export * from "./goods-info.vue?vue&type=script&lang=js"
import style0 from "./goods-info.vue?vue&type=style&index=0&id=bebc30fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebc30fe",
  null
  
)

export default component.exports